angular.module('inhouseNoticeList', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/boards/inhouse-notice/inhouse-notice-list/inhouse-notice-list.module.js